import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { AppBar, CardContent, Toolbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SearchBox from "../../common/components/SearchBox";
import { useTheme } from "@mui/material/styles";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

import {
  getVotingHighestScores,
  publishVoting,
} from "../../../store/voting/actions";
import DepartmentLeftSide from "../components/DepartmentLeftSide";
import VoteCard from "../components/VoteCard";
import VoteDetailsDialog from "../components/VoteDetailsDialog";
import VotingForm from "../components/VotingForm";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";

const HighestScores = (props) => {
  const { getVotingHighestScores, votingHighestScores, publishVoting, user } = props;
  const { hasPermissions } = useRequiredAuth();
  const [showVotingForm, setShowVotingForm] = useState(false);
  const location = useLocation();
  useEffect(() => {
    document.title = `IPPIS - Highest Scores(${votingHighestScores.length}) | Voting`;
  }, [votingHighestScores]);
  const [loading, setLoading] = useState(false);
  const [searchTeam, setSearchTeam] = useState("");
  const theme = useTheme();
  const [selectedVote, setSelectedVote] = useState(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([...votingHighestScores]);
  const [confirmToPublishVoting, setConfirmToPublishVoting] = useState(false);
  const [publishing, setPublishing] = useState(false);

  const isDepartment =
    location.pathname.includes("/voting/departments") || false;

  useEffect(() => {
    getVotingHighestScores(isDepartment ? "D" : "M", setLoading);
  }, []);

  useEffect(() => {
    const filtered = [...votingHighestScores].filter(
      ({ names, phoneNumber, positionName, unitName }) =>
        (names || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (phoneNumber || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (positionName || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (unitName || "").toLowerCase().includes(searchTeam.toLowerCase())
    );

    setFilteredData(filtered);
  }, [searchTeam, votingHighestScores]);

  const onSearch = (term) => {
    setSearchTeam(term);
  };
  const handleViewDetails = (vote) => {
    setSelectedVote(vote);
    setIsDetailsOpen(true);
  };
  // Close dialog
  const handleCloseDetails = () => {
    setSelectedVote(null);
    setIsDetailsOpen(false);
  };

  function groupAndSortVotes(data) {
    const grouped = {};

    data.forEach((item) => {
      const groupKey = `${item.groupId}__${item.groupName}`;
      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          groupId: item.groupId,
          groupName: item.groupName,
          members: [],
        };
      }
      grouped[groupKey].members.push(item);
    });

    // Sort each group's members
    for (const key in grouped) {
      grouped[key].members.sort((a, b) => {
        const aManagement = a.managementNo ?? 0;
        const bManagement = b.managementNo ?? 0;
        const aDept = a.departmentNo ?? 0;
        const bDept = b.departmentNo ?? 0;

        if (aManagement !== bManagement) return aManagement - bManagement;
        return aDept - bDept;
      });
    }

    // Return array instead of object
    return Object.values(grouped);
  }

  // console.log(user)
  return (
    <div className="row mx-0">
      {!!isDepartment && (
        <div className="col-2">
          <DepartmentLeftSide />
        </div>
      )}

      <div className={`${!!isDepartment ? "col-10" : "col-12"} mt-2`}>
        <AppBar
          position="static"
          elevation={0}
          style={{ overflow: "hidden" }}
          className="app-bar w-100"
        >
          <Toolbar className="row justify-content-between">
            <div className="col-lg-8">
              <Typography
                variant="h6"
                noWrap
                component="div"
                // sx={{ display: { xs: "none", sm: "block" } }}
              >
                <span>VOTING</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span>{!!isDepartment ? "Department" : "Management"}</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span style={{ color: "rgb(7, 142, 206)" }}>
                  <span style={{ color: "rgb(7, 142, 206)" }}>
                    Highest Scores
                  </span>
                </span>
              </Typography>
            </div>

            <div className="col-lg-4 d-flex justify-content-between">
              <div className="w-100">
                <SearchBox
                  disabled={!votingHighestScores.length}
                  onSearch={onSearch}
                  placeholder="Search…"
                />
              </div>
              <div className="d-flex justify-content-between">
                <Button
                  sx={{ borderRadius: 2 }}
                  style={{ width: "80px" }}
                  className="px-3 ml-2"
                  variant="contained"
                  color="primary"
                  onClick={() => setShowVotingForm(true)}
                  size="md"
                >
                  <span className="material-icons">add</span>Vote
                </Button>

                {hasPermissions(["IS_HR"]) && (
                  <Button
                    sx={{ borderRadius: 2 }}
                    style={{ width: "170px" }}
                    color="success"
                    variant="contained"
                    className="px-2 ml-2"
                    onClick={() => setConfirmToPublishVoting(true)}
                    size="sm"
                  >
                    <span className="material-icons">publish</span>Publish
                    Voting
                  </Button>
                )}
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div
          style={{
            padding: theme.spacing(0.4),
            height: "auto",
            maxHeight: "auto",
            margin: "1.2em",
            backgroundColor: "#fff",
            borderRadius: "0.5rem",
            overflow: "visible",
            boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
            MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
          }}
        >
          <CardContent
            style={{
              padding: ".1em",
              height: "auto",
              minHeight: "auto",
              overflow: "auto",
            }}
          >
            <div className="row mt-3 mx-2">
              {filteredData.length > 0 ? (
                <div className="col-12">
                  {!!isDepartment ? (
                    <div className="row">
                      {groupAndSortVotes(filteredData).map((group) => (
                        <div className="col-12 mb-4" key={group.groupId}>
                          <span
                            className="font-weight-bold d-flex align-items-center"
                            // style={{ borderBottom: "1px solid #ccc" }}
                          >
                            <span className="material-icons-round mr-1">
                              group
                            </span>
                            <span>{group.groupName}</span>
                          </span>

                          <div className="row mt-2">
                            {group.members.map((vote) => (
                              <div
                                className="col-1 col-lg-4 col-md-4 mb-4"
                                key={vote.id}
                              >
                                {/* Real Vote Card */}
                                <VoteCard
                                  item={vote}
                                  onViewDetails={handleViewDetails}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="row">
                      {filteredData.map((vote) => (
                        <div
                          className="col-1 col-lg-4 col-md-4 mb-4"
                          key={vote.id}
                        >
                          {/* Real Vote Card */}
                          <VoteCard
                            item={vote}
                            onViewDetails={handleViewDetails}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                // No Votes Message
                <div className="col text-center mt-5">
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    😕{" "}
                    {!!searchTeam
                      ? "No data found"
                      : "No votes have been made yet."}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Start voting to see the voting history here!
                  </Typography>
                </div>
              )}
            </div>

            {showVotingForm && (
              <VotingForm
                showVotingForm={showVotingForm}
                setShowVotingForm={setShowVotingForm}
              />
            )}

            {isDetailsOpen && (
              <VoteDetailsDialog
                open={isDetailsOpen}
                onClose={handleCloseDetails}
                voteData={selectedVote}
              />
            )}
          </CardContent>
        </div>
      </div>

      {confirmToPublishVoting && (
        <ConfirmationDialog
          confirmationDialog={confirmToPublishVoting}
          message={`Are you sure you want to publish voting on management level?`}
          setConfirmationDialog={() => setConfirmToPublishVoting(false)}
          isLoading={publishing}
          disabled={publishing}
          onYes={() =>
            publishVoting("M", (status, res) => {
              setConfirmToPublishVoting(status);
              setPublishing(status);
              if (!status && !!res) {
                getVotingHighestScores("M", setLoading);
              }
            })
          }
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ user, votingHighestScores }) => {
  return { user, votingHighestScores };
};

const mapDispatchToProps = {
  getVotingHighestScores,
  publishVoting,
};

export default connect(mapStateToProps, mapDispatchToProps)(HighestScores);
